<ngrx-store-log-monitor #storeMonitor
  toggleCommand="ctrl-t" 
  positionCommand="ctrl-m" 
  [expandEntries]="true">
</ngrx-store-log-monitor>